import React from 'react';
import { useForm } from 'react-hook-form';
import { replaceDefaultValues } from '../../helpers/form';
import FormElement from '../core/FormElement';
import StepFormSubStepButtons from '../StepForm/StepFormSubStepButtons';

interface Props {
  onSubmit: (data: { [x: string]: any }) => void;
  onBackClick: () => void;
  defaultValues?: any;
}

export default function Form3(props: Props) {
  const { register, handleSubmit, errors, control } = useForm({
    defaultValues: replaceDefaultValues(
      {
        infoSquareMeters: '',
        infoRooms: 1,
        infoToilets: 1,
        infoParkings: 1,
      },
      props.defaultValues
    ),
  });

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <h1>Características de tu propiedad</h1>

      <FormElement
        name="infoSquareMeters"
        label="Área de la propiedad*"
        placeholder="Metros cuadrados"
        inputRef={register({ required: true, valueAsNumber: true })}
        error={errors.infoSquareMeters}
        elementType="number"
        step=".01"
      />

      <FormElement
        control={control}
        name="infoRooms"
        label="Número de habitaciones"
        elementType="numberButtons"
        inputRef={register}
        min={0}
        max={10}
      />

      <FormElement
        control={control}
        name="infoToilets"
        label="Número de baños"
        elementType="numberButtons"
        inputRef={register}
        min={0}
        max={5}
      />

      <FormElement
        control={control}
        name="infoParkings"
        label="Número de parqueaderos"
        elementType="numberButtons"
        inputRef={register}
        min={0}
        max={5}
      />

      <StepFormSubStepButtons onBackClick={props.onBackClick} />
    </form>
  );
}
